import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserState } from '../../../store/user/user.reducer';
import {
  selectUserAccount,
  selectUserPhoto,
} from '../../../store/user/user.selectors';

@Component({
  standalone: false,
  selector: 'app-user-button',
  templateUrl: './user-button.component.html',
  styleUrls: ['./user-button.component.scss'],
})
export class UserButtonComponent {
  constructor(private store: Store<{ user: UserState }>) {}

  readonly currentUserProfile$ = this.store.select(selectUserAccount);
  userImage$ = this.store.select(selectUserPhoto);
}
